import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const WS_BASE = BACKEND_URL.replace(/^http/, "ws") + "/api/ws";

export const LANGS = {
  es: { code: "es", speech: "es-ES", label: "Español", native: "Español", dir: "ltr" },
  ar: { code: "ar", speech: "ar-MA", label: "Darija", native: "الدارجة", dir: "rtl" },
};

export const other = (lang) => (lang === "es" ? "ar" : "es");

function handleSseEvent(line, { onDelta, onDone }) {
  if (!line.startsWith("data:")) return;
  const ev = JSON.parse(line.slice(5));
  if (ev.error) throw new Error(ev.error);
  if (ev.delta) onDelta?.(ev.delta);
  if (ev.done) onDone?.(ev.translation, ev.cached);
}

export async function translateStream(text, source, { onDelta, onDone, onError }) {
  try {
    const res = await fetch(`${API}/translate`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ text, source }),
    });
    if (!res.ok || !res.body) throw new Error(`HTTP ${res.status}`);
    const reader = res.body.getReader();
    const decoder = new TextDecoder();
    let buf = "";
    while (true) {
      const { value, done } = await reader.read();
      if (done) break;
      buf += decoder.decode(value, { stream: true });
      const parts = buf.split("\n\n");
      buf = parts.pop();
      parts.forEach((part) => handleSseEvent(part.trim(), { onDelta, onDone }));
    }
  } catch (e) {
    onError?.(e);
  }
}

export const createRoom = () => axios.post(`${API}/rooms`).then((r) => r.data);
export const getRoom = (code) => axios.get(`${API}/rooms/${code}`).then((r) => r.data);
export const getRoomMessages = (code) => axios.get(`${API}/rooms/${code}/messages`).then((r) => r.data);
export const getStats = () => axios.get(`${API}/stats`).then((r) => r.data);
